<template>
  <UIInputText
    v-model="modelValue"
    :data-refid="dataRefid"
    :label
    :disabled
    :error
    :silent
    :size
    @ready="onReady"
  />
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { AssetClass } from '..'
import { InputSize } from '@types'

import { ASSET_FIELD } from '../utils/const'

import { UIInputText } from '@ui/fields'

type Props = {
  instance: AssetClass
  disabled?: boolean
  label?: string
  focusOnLoad?: boolean
  dataRefid?: string
  size?: InputSize
}

const props = defineProps<Props>()

const modelValue = props.instance.field<string>(ASSET_FIELD.DESCRIPTION)

const isSavedAsset = inject('isSavedAsset', ref(false))

const error = computed(() => props.instance.errors.description)
const silent = computed(() => !isSavedAsset.value)

const onReady = (el: HTMLInputElement) => {
  if (!props.focusOnLoad) return
  el.focus()
}
</script>
